import classNames from "classnames/bind";
import styles from "./Footer.module.scss";
import imageFacebook from "../../../assets/images/facebook.webp";
import imageInstagram from "../../../assets/images/instagram.webp";
import imageTiktok from "../../../assets/images/tiktok.webp";
import imageYoutube from "../../../assets/images/youtube.webp";
import imageZalo from "../../../assets/images/zalo.webp";
import { useState } from "react";
import { callCreateEmailFollow } from "../../../config/api";
import { message } from "antd";

const css = classNames.bind(styles);
function Footer() {
  const [email, setEmail] = useState("");
  const handleAddEmailFollow = async () => {
    const result = await callCreateEmailFollow({ email });
    if (result.statusCode === 201) {
      message.success(result.message);
    } else if (result.statusCode === 401) {
      message.warning("Vui lòng đăng nhập tài khoản!");
    } else {
      message.error(result.message);
    }
  };
  return (
    <div className={css("wrapper")}>
      <div className={css("footer-up")}>
        <div className={css("col-footer")}>
          <h3>Theo dõi</h3>
          <p>
            Hãy nhập thông tin dưới đây để nhận các bài viết mới nhất từ chúng
            tôi.
          </p>

          <input
            className={css("input-footer")}
            type="text"
            placeholder="Nhập email của bạn..."
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className={css("btn-footer")} onClick={handleAddEmailFollow}>
            subscribe now
          </button>
        </div>
        <div className={css("col-footer")}>
          <h3>Giới thiệu</h3>
          <p>
            Việt Anh Blogger được xây dựng với phương châm: "Chia sẻ không giới
            hạn". Là blog cộng đồng - mong muốn chia sẻ những hiểu biết, kiến
            thức về cuộc sống, sức khỏe, công việc, học tập, tài liệu được chia
            sẻ đến tất cả mọi người hoàn toàn miễn phí.
          </p>
          <br />
        </div>
        <div className={css("col-footer")}>
          <div>
            <h3>Liện hệ</h3>
            <p>Địa chỉ: Đội 5, Thôn 1, Thạch Đà, Mê Linh, Hà Nội</p>
            <p>Email: vietanhhappy99@gmail.com</p>
            <p>Facebook: Việt Anh</p>
          </div>
          <div className={css("social-logo")}>
            <img src={imageFacebook} alt="logo" />
            <img src={imageInstagram} alt="logo" />
            <img src={imageTiktok} alt="logo" />
            <img src={imageYoutube} alt="logo" />
            <img src={imageZalo} alt="logo" />
          </div>
        </div>
      </div>
      <div className={css("footer-down")}>
        <p>Copyright © 2022 - 2023 happy24h.com</p>
        <p>Created by Việt Anh Blogger All Right Reserved</p>
      </div>
    </div>
  );
}

export default Footer;
